import {createTheme, responsiveFontSizes} from "@mui/material";

export const islandTheme = responsiveFontSizes(createTheme({
        typography:{
            fontFamily:"'Termina', sans-serif"
        },
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        background: "#509F33",
                        boxShadow: 'none'
                    }
                }
            },
            MuiToolbar: {
                styleOverrides: {
                    root: {
                        padding: 0
                    }
                }
            },
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: '50rem',
                        paddingInline: '1.5rem'
                    }
                }
            },
            MuiPaper:{
                styleOverrides:{
                    root:{
                        backgroundImage:'none'
                    }
                }
            },
            MuiContainer: {
                styleOverrides: {
                    maxWidthXl: {
                        '&.MuiContainer-maxWidthXl': {
                            maxWidth: '115rem',
                        }
                    },
                    maxWidthLg: {
                        '&.MuiContainer-maxWidthLg': {
                            maxWidth: '90rem',
                        }
                    },
                    maxWidthMd: {
                        '&.MuiContainer-maxWidthMd': {
                            maxWidth: '78rem',
                        }
                    }
                }
            }
        },
        palette: {
            mode: "dark",
            background: {
                default: '#509F33',
                paper:'#509F33'
            },
            text:{
                primary: "#FFFFFF"
            },
            primary: {
                main: '#F08906',
                contrastText:'#FFFFFF'
            },
            secondary:{
                main: '#FFFFFF'
            },
            action:{
                active:'#509F33'
            }
        }
    }
))
